import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Button,
  Col,
  Container,
  Modal,
  Row,
  Form,
  FormGroup,
  Label,
  ModalBody,
} from 'reactstrap';
import { AddUserButton, FilterButton } from '../../Components/CommonComponents';
import { DashBoardTitle } from '../../Components/Title';
import { PunchInOutModal } from './PunchInOutModal';
import excelImg from '../../images/excel.png';
import './style.css';
import { CommonButton } from '../../Components/CommonComponents';
import closeImg from '../../images/modalclose.png';
import Pagination from '../../Components/Pagination/Pagination';
import Lightbox from 'react-image-lightbox';
import Storage from '../../services/Storage';
import CustomSpinner from '../../Components/CustomSpinner/CustomSpinner';
import { Roles } from '../../constants/Roles';
import {
  getNationalHeadList,
  getPunchingData,
  getStateHeadList,
  getStateHeadTMById,
  getStateOfStateHead,
  getTerritoriesById,
} from '../../constants/apiCalls';
import { handleErrorMessage } from '../../utils/utils';
import ModalService from '../../services/ModalService';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import AppHeader from '../../Layout/AppHeader';
import AppSidebar from '../../Layout/AppSidebar';

// const initialInputValue = {
//   nationalHead: '',
//   stateHead: '',
//   state: '',
//   territoryManager: '',
//   territory: '',
//   startDate: '',
//   endDate: '',
// };

export const Travel = () => {
  let isMobile = false;
  const { search } = useLocation();
  isMobile = new URLSearchParams(search).get('isMobile');

  const [punchInModal, setPunchInModal] = useState({
    punchIn: false,
    punchOut: false,
  });

  const [punchOutId, setPunchOutId] = useState(null);
  const [punchOutUserId, setPunchOutUserId] = useState(null);
  const [punchOutData, setPunchOutData] = useState({});

  const [totalKM, setTotalKM] = useState(0);

  const [isLoading, setIsloading] = useState(false);
  const [imgModal, setImgModal] = useState(false);

  const [filterModal, setFilterModal] = useState(false);
  const [imgUrl, setImgUrl] = useState(false);
  // const [inputValue, setInputValue] = useState(initialInputValue);

  let pageNo = useMemo(() => Storage.getDistanceTravelPage(), [
    Storage.getDistanceTravelPage(),
  ]);
  const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
  const [pageSize, setPageSize] = useState(5);
  const [filterbtnActive, setFilterBtnActive] = useState(false);
  const [data, setData] = useState([]);

  const handleIsModal = (id) => {
    if (id === 'PunchIn') {
      let value = punchInModal.punchIn;
      setPunchInModal((previousState) => {
        return { ...previousState, punchIn: !value };
      });
    }
    if (id === 'PunchOut') {
      let value = punchInModal.punchOut;
      setPunchInModal((previousState) => {
        return { ...previousState, punchOut: !value };
      });
    }
  };

  const toggleImgModal = (id, index) => {
    setImgModal(!imgModal);
    if (id === 1) setImgUrl(data[index].speedometer_image_in);
    else setImgUrl(data[index].speedometer_image_out);
  };

  const handleApplyFilter = (e) => {
    e.preventDefault();
    setFilterModal(false);
    setFilterBtnActive(true);
    fetchData();
    setPage(1);
    Storage.setDistanceTravelPage(1);
  };

  const handleClickExcel = () => {
    setIsloading(true);

    const payload = { pagesize: pageSize, page, is_download: true };

    if (nhId) {
      payload.nh_id = nhId;
    }
    if (stateId) {
      payload.state_id = stateId;
    }
    if (shId) {
      payload.sh_id = shId;
    }
    if (tmId) {
      payload.tm_id = tmId;
    }
    if (territoryId) {
      payload.territory_id = territoryId;
    }
    if (startDate) {
      payload.start_date = startDate;
    }
    if (endDate) {
      payload.end_date = endDate;
    }

    getPunchingData((res) => {
      const { data, success, error } = res;
      if (success === true) {
        window.open(data.file, '_blank');
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const handleInputChange = useCallback(
    (e) => {
      let pageSize = parseInt(e.target.value);
      setPageSize(pageSize);
      setPage(1);
    },
    [page, pageSize],
  );
  const handlePageChange = useCallback(
    (page) => {
      setPage(page);
      Storage.setDistanceTravelPage(page);
    },
    [page, pageSize],
  );

  // User Filter Data
  let userInfo = Storage.getUserInfoDetail();
  let userId = userInfo ? userInfo.id : null;
  let roleName = userInfo ? userInfo.role : '';

  // National Head
  const [nhList, setNhList] = useState([]);
  const [nhId, setnhId] = useState('');

  // State Head
  const [shList, setShList] = useState([]);
  const [shId, setShId] = useState('');

  // State
  const [stateFilterList, setStateFilterList] = useState([]);
  const [stateId, setStateId] = useState('');

  // TM
  const [tmList, setTmList] = useState([]);
  const [tmFilterList, setTmFilterList] = useState([]);
  const [tmListAll, setTmListAll] = useState([]);
  const [tmId, setTmId] = useState('');

  // Territory
  const [territoryList, setTerritoryList] = useState([]);
  const [territoryFilterList, setTerritoryFilterList] = useState([]);
  const [territoryId, setTerritoryId] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleResetFilter = () => {
    fetchData();
    setFilterModal(false);
    // setInputValue(initialInputValue);
    setnhId('');
    setShId('');
    setStateId('');
    setTmId('');
    setStartDate(null);
    setEndDate(null);
    setFilterBtnActive(false);
    setPage(1);
    Storage.setDistanceTravelPage(1);
  };

  let userDataAll = Storage.getBreadcrumbsrRecord();
  let userData = useMemo(
    () =>
      userDataAll.reduce((unique, o) => {
        if (!unique.some((obj) => obj.id === o.id && obj.role === o.role)) {
          if (o.filter) {
            unique.push(o.filter);
          }
        }
        return unique;
      }, []),
    [],
  );

  const fetchData = () => {
    setIsloading(true);

    const payload = { pagesize: pageSize, page };

    if (nhId) {
      payload.nh_id = nhId;
    }
    if (stateId) {
      payload.state_id = stateId;
    }
    if (shId) {
      payload.sh_id = shId;
    }
    if (tmId) {
      payload.tm_id = tmId;
    }
    if (territoryId) {
      payload.territory_id = territoryId;
    }
    if (startDate) {
      payload.start_date = startDate;
    }
    if (endDate) {
      payload.end_date = endDate;
    }

    getPunchingData((res) => {
      const { data, success, error } = res;

      if (success) {
        setIsloading(false);

        setTotalKM(data[0].total_entry_km[0].total_km || 0);
        setData(data[0].distance_data || []);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
        setIsloading(false);
      }
    }, payload);
  };

  // Get Travel Data
  useEffect(() => {
    fetchData();
  }, [pageSize, page]);

  // TH Role
  useEffect(() => {
    if (roleName === Roles.TM_NAME) {
      let payload = {
        id: userId,
      };
      getTerritoriesById((res) => {
        const { data, success, error } = res;
        if (success === true) {
          setTerritoryList(data);
          setTerritoryFilterList(data);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
    }
  }, [userId]);

  // SH Role
  useEffect(() => {
    if (roleName === Roles.SH_NAME) {
      let tempTmid = null;
      let tempStateid = null;

      let statebyShPayload = {
        id: userId,
      };
      getStateOfStateHead((res) => {
        const { data, success, error } = res;
        if (success === true) {
          if (data && data.length > 0 && data[0].id) {
            tempStateid = data[0].id;
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, statebyShPayload);

      let selectedId =
        userData && userData.length > 0
          ? userData.filter((val) => val.role === 'TM')
          : [];

      if (selectedId && selectedId.length > 0) {
        tempTmid = selectedId[0].id;
        setTmId(selectedId[0].id);
      }

      let payload = {
        id: userId,
      };

      getStateHeadTMById((res) => {
        const { data, success, error } = res;
        if (success === true) {
          let filterData = data && data.length > 0 ? data[0] : [];
          if (filterData && filterData.state) {
            setStateFilterList(filterData.state);
          }

          if (filterData && filterData.territory_manager) {
            setTmListAll(filterData.territory_manager); // have duplicate tm
            setTmList([
              ...new Map(
                filterData.territory_manager.map((m) => [m.user_id, m]),
              ).values(),
            ]); // removed dulpicate tm
            setTmFilterList([
              ...new Map(
                filterData.territory_manager.map((m) => [m.user_id, m]),
              ).values(),
            ]); // removed dulpicate tm
          }

          if (filterData && filterData.territory) {
            setTerritoryList(filterData.territory);
            if (tempTmid && filterData.territory_manager) {
              let filterTmbyId = filterData.territory_manager.filter(
                (e) => e.user_id === tempTmid,
              );
              let territoryIdArr = filterTmbyId
                ? filterTmbyId.map((e) => e.territory_id)
                : [];
              let territoryArr = filterData.territory.filter((e) =>
                territoryIdArr.includes(e.territory_id),
              );
              let uniqueTerritoryData =
                territoryArr && territoryArr.length > 0
                  ? [
                    ...new Map(
                      territoryArr.map((m) => [m.territory_id, m]),
                    ).values(),
                  ]
                  : [];
              setTerritoryFilterList(uniqueTerritoryData);
            } else if (tempStateid) {
              let filterTerritorybyState = filterData.territory.filter(
                (e) => e.state_id === tempStateid,
              );
              setTerritoryFilterList(filterTerritorybyState);
            } else {
              let filteredTMBH = filterData
                ? [
                  ...new Map(
                    filterData.territory.map((m) => [m.territory_id, m]),
                  ).values(),
                ]
                : [];
              setTerritoryFilterList(filteredTMBH);
            }
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
    }
  }, [userId]);

  // NH Role
  useEffect(() => {
    if (roleName === Roles.NH_NAME) {
      let tempShid = null;
      let tempTmid = null;
      let tempStateid = null;

      let selectedShId =
        userData && userData.length > 0
          ? userData.filter((val) => val.role === 'SH')
          : [];
      if (selectedShId && selectedShId.length > 0) {
        setShId(selectedShId[0].id);
        tempShid = selectedShId[0].id;
        tempStateid = selectedShId[0].state_id;
        setStateId(selectedShId[0].state_id);
      }

      let selectedTMId =
        userData && userData.length > 0
          ? userData.filter((val) => val.role === 'TM')
          : [];
      if (selectedShId && selectedShId.length > 1) {
        setTmId(selectedShId[0].id);
        tempTmid = selectedShId[0].id;
      } else if (selectedTMId && selectedTMId.length > 0) {
        setTmId(selectedTMId[0].id);
        tempTmid = selectedTMId[0].id;
      }

      let payload = {
        id: userId,
      };
      getStateHeadList((resp) => {
        const { data, success, error } = resp;
        if (success === true) {
          setShList(data);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);

      let statePayload = {
        id: tempShid || userId,
      };
      getStateHeadTMById((res) => {
        const { data, success, error } = res;
        if (success === true) {
          let filterData = data && data.length > 0 ? data[0] : [];

          if (filterData) {
            if (filterData.state) {
              setStateFilterList(filterData.state);
            }
            if (filterData.territory_manager) {
              setTmListAll(filterData.territory_manager); // have duplicate tm
              setTmList([
                ...new Map(
                  filterData.territory_manager.map((m) => [m.user_id, m]),
                ).values(),
              ]); // removed dulpicate tm
              if (tempStateid && filterData.territory_manager) {
                let filterTmByState = filterData.territory_manager.filter(
                  (e) => e.state_id === tempStateid,
                ); // have duplicate Tm
                let uniqueTmByState =
                  filterTmByState && filterTmByState.length > 0
                    ? [
                      ...new Map(
                        filterTmByState.map((m) => [m.user_id, m]),
                      ).values(),
                    ]
                    : []; //remove duplicate tm
                setTmFilterList(uniqueTmByState);
              } else {
                setTmFilterList([
                  ...new Map(
                    filterData.territory_manager.map((m) => [m.user_id, m]),
                  ).values(),
                ]); // removed dulpicate tm
              }
            }
            if (filterData.territory) {
              setTerritoryList(filterData.territory);
              if (tempTmid && filterData.territory_manager) {
                let filterTmbyId = filterData.territory_manager.filter(
                  (e) => e.user_id === tempTmid,
                );
                let territoryIdArr = filterTmbyId
                  ? filterTmbyId.map((e) => e.territory_id)
                  : [];
                let territoryArr = filterData.territory.filter((e) =>
                  territoryIdArr.includes(e.territory_id),
                );
                let uniqueTerritoryData =
                  territoryArr && territoryArr.length > 0
                    ? [
                      ...new Map(
                        territoryArr.map((m) => [m.territory_id, m]),
                      ).values(),
                    ]
                    : [];
                setTerritoryFilterList(uniqueTerritoryData);
              } else if (tempStateid) {
                let filterTerritorybyState = filterData.territory.filter(
                  (e) => e.state_id === tempStateid,
                );
                setTerritoryFilterList(filterTerritorybyState);
              } else {
                let filteredTMBH = filterData
                  ? [
                    ...new Map(
                      filterData.territory.map((m) => [m.territory_id, m]),
                    ).values(),
                  ]
                  : [];
                setTerritoryFilterList(filteredTMBH);
              }
            }
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, statePayload);
    }
  }, [userId]);

  // BH Role
  useEffect(() => {
    if (roleName === Roles.BH_NAME) {
      let tempNhid = null;
      let tempShid = null;
      let tempTmid = null;
      let tempStateid = null;
      let selectedBHNhId =
        userData && userData.length > 0
          ? userData.filter((val) => val.role === 'NH')
          : [];
      if (selectedBHNhId && selectedBHNhId.length > 0) {
        setnhId(selectedBHNhId[0].id);
        tempNhid = selectedBHNhId[0].id;
        tempStateid = selectedBHNhId[0].state_id;
        setStateId(selectedBHNhId[0].state_id);
      }

      let selectedBHShId =
        userData && userData.length > 0
          ? userData.filter((val) => val.role === 'SH')
          : [];

      if (selectedBHNhId && selectedBHNhId.length > 1) {
        setShId(selectedBHNhId[0].id);
        tempShid = selectedBHNhId[0].id;
        tempStateid = selectedBHNhId[0].state_id;
        setStateId(selectedBHNhId[0].state_id);
      } else if (selectedBHShId && selectedBHShId.length > 0) {
        setShId(selectedBHShId[0].id);
        tempShid = selectedBHShId[0].id;
        tempStateid = selectedBHShId[0].state_id;
        setStateId(selectedBHShId[0].state_id);
      }

      let selectedBHTmId =
        userData && userData.length > 0
          ? userData.filter((val) => val.role === 'TM')
          : [];
      if (selectedBHNhId && selectedBHNhId.length > 2) {
        setTmId(selectedBHNhId[0].id);
        tempTmid = selectedBHNhId[0].id;
      } else if (selectedBHShId && selectedBHShId.length > 1) {
        setTmId(selectedBHShId[0].id);
        tempTmid = selectedBHShId[0].id;
      } else if (selectedBHTmId && selectedBHTmId.length > 0) {
        tempTmid = selectedBHTmId[0].id;
        setTmId(selectedBHTmId[0].id);
      }

      let nationalPayload = {
        id: userId,
      };
      getNationalHeadList((rsp) => {
        const { data, success, error } = rsp;
        if (success) {
          setNhList(data);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, nationalPayload);
      let payload = {
        id: tempNhid || userId,
      };
      getStateHeadList((resp) => {
        const { data, success, error } = resp;
        if (success === true) {
          setShList(data);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
      let statePayload = {
        id: tempShid || tempNhid || userId,
      };
      getStateHeadTMById((res) => {
        const { data, success, error } = res;
        if (success === true) {
          let filterData = data && data.length > 0 ? data[0] : [];
          if (filterData) {
            if (filterData.state) {
              setStateFilterList(filterData.state);
            }
            if (filterData.territory_manager) {
              setTmListAll(filterData.territory_manager); // have duplicate tm
              setTmList([
                ...new Map(
                  filterData.territory_manager.map((m) => [m.user_id, m]),
                ).values(),
              ]); // removed dulpicate tm
              if (tempStateid && filterData.territory_manager) {
                let filterTmByState = filterData.territory_manager.filter(
                  (e) => e.state_id === tempStateid,
                ); // have duplicate Tm
                let uniqueTmByState =
                  filterTmByState && filterTmByState.length > 0
                    ? [
                      ...new Map(
                        filterTmByState.map((m) => [m.user_id, m]),
                      ).values(),
                    ]
                    : []; //remove duplicate tm
                setTmFilterList(uniqueTmByState);
              } else {
                setTmFilterList([
                  ...new Map(
                    filterData.territory_manager.map((m) => [m.user_id, m]),
                  ).values(),
                ]); // removed dulpicate tm
              }
            }
            if (filterData.territory) {
              setTerritoryList(filterData.territory);
              if (tempTmid && filterData.territory_manager) {
                let filterTmbyId = filterData.territory_manager.filter(
                  (e) => e.user_id === tempTmid,
                );
                let territoryIdArr = filterTmbyId
                  ? filterTmbyId.map((e) => e.territory_id)
                  : [];
                let territoryArr = filterData.territory.filter((e) =>
                  territoryIdArr.includes(e.territory_id),
                );
                let uniqueTerritoryData =
                  territoryArr && territoryArr.length > 0
                    ? [
                      ...new Map(
                        territoryArr.map((m) => [m.territory_id, m]),
                      ).values(),
                    ]
                    : [];
                setTerritoryFilterList(uniqueTerritoryData);
              } else if (tempStateid) {
                let filterTerritorybyState = filterData.territory.filter(
                  (e) => e.state_id === tempStateid,
                );
                setTerritoryFilterList(filterTerritorybyState);
              } else {
                let filteredTMBH = filterData
                  ? [
                    ...new Map(
                      filterData.territory.map((m) => [m.territory_id, m]),
                    ).values(),
                  ]
                  : [];
                setTerritoryFilterList(filteredTMBH);
              }
            }
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, statePayload);
    }
  }, [userId]);

  const handleChange = (e) => {
    if (e.target.name === 'nationalHeadName') {
      let val = e.target.value;
      setnhId(val);

      setPage(1);
      setShId('');
      setStateId('');
      setTmId('');
      setTerritoryId('');
      let nationalPayload = {
        id: val || userId,
      };
      getStateHeadList((rsp) => {
        const { data, success, error } = rsp;
        if (success === true) {
          setShList(data);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, nationalPayload);

      getStateHeadTMById((rsp) => {
        const { data, success, error } = rsp;
        if (success === true) {
          if (data && data.length > 0) {
            let filterData = data[0];
            if (filterData) {
              if (filterData.territory_manager) {
                setTmFilterList([
                  ...new Map(
                    filterData.territory_manager.map((m) => [m.user_id, m]),
                  ).values(),
                ]); // removed dulpicate tm
              }
              if (filterData.state) {
                setStateFilterList(filterData.state);
              }
              if (filterData.territory) {
                let filteredTMBH = filterData
                  ? [
                    ...new Map(
                      filterData.territory.map((m) => [m.territory_id, m]),
                    ).values(),
                  ]
                  : [];
                setTerritoryFilterList(filteredTMBH);
              }
            }
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, nationalPayload);
    }
    if (e.target.name === 'stateHeadName') {
      let val = e.target.value;
      setShId(e.target.value);

      setPage(1);
      setStateId('');
      setTmId('');
      setTerritoryId('');

      let payload = {
        id: val || nhId || userId,
      };
      getStateHeadTMById((resp) => {
        const { data, success, error } = resp;
        if (success === true) {
          if (data && data.length > 0) {
            if (data[0].state) {
              setStateFilterList(data[0].state);
            }
            if (data[0].territory_manager) {
              setTmListAll(data[0].territory_manager); // have duplicate tm
              setTmList([
                ...new Map(
                  data[0].territory_manager.map((m) => [m.user_id, m]),
                ).values(),
              ]); // removed dulpicate tm
              setTmFilterList([
                ...new Map(
                  data[0].territory_manager.map((m) => [m.user_id, m]),
                ).values(),
              ]); // removed dulpicate tm
            }
            if (data[0].territory) {
              setTerritoryList(data[0].territory);
              setTerritoryFilterList(data[0].territory);
            }
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
    }
    if (e.target.name === 'stateName') {
      let val = e.target.value;
      setStateId(val);

      setPage(1);
      setTmId('');
      setTerritoryId('');
      if (val) {
        let filterTMAll =
          tmListAll && tmListAll.length > 0
            ? tmListAll.filter((elem) => elem.state_id === +val)
            : [];
        let uniqueTm =
          filterTMAll && filterTMAll.length > 0
            ? [...new Map(filterTMAll.map((m) => [m.user_id, m])).values()]
            : [];
        setTmFilterList(uniqueTm);
        let filterTerritory =
          territoryList && territoryList.length > 0
            ? territoryList.filter((elem) => elem.state_id === +val)
            : [];
        setTerritoryFilterList(filterTerritory);
      } else {
        setTmFilterList(tmList);
        let uniqueTerritory =
          territoryList && territoryList.length > 0
            ? [
              ...new Map(
                territoryList.map((m) => [m.territory_id, m]),
              ).values(),
            ]
            : [];
        setTerritoryFilterList(uniqueTerritory);
      }
    }
    if (e.target.name === 'tmName') {
      let val = e.target.value;
      setTmId(val);

      setPage(1);
      setTerritoryId('');
      if (val) {
        let filterTM =
          tmListAll && tmListAll.length > 0
            ? tmListAll.filter((elem) => elem.user_id === +val)
            : [];
        let filterTerritoryArr =
          filterTM && filterTM.length > 0
            ? filterTM.map((val) => {
              return val.territory_id;
            })
            : []; // territory id array
        let filterTerritory =
          territoryList && territoryList.length > 0
            ? territoryList.filter((elem) =>
              filterTerritoryArr.includes(elem.territory_id),
            )
            : [];
        let uniqueFilterTerritory =
          filterTerritory && filterTerritory.length > 0
            ? [
              ...new Map(
                filterTerritory.map((m) => [m.territory_id, m]),
              ).values(),
            ]
            : [];
        setTerritoryFilterList(uniqueFilterTerritory);
      } else {
        let uniqueTerritory =
          territoryList && territoryList.length > 0
            ? [
              ...new Map(
                territoryList.map((m) => [m.territory_id, m]),
              ).values(),
            ]
            : [];
        setTerritoryFilterList(uniqueTerritory);
      }
    }
    if (e.target.name === 'territoryName') {
      let val = e.target.value;
      setTerritoryId(val);

      setPage(1);
    }

    if (e.target.name === 'startDate') {
      let value = e.target.value;
      setStartDate(value);

      setPage(1);
    }
    if (e.target.name === 'endDate') {
      let value = e.target.value;
      setEndDate(value);

      setPage(1);
    }
  };


  return (
    <>
      {(isMobile === 'false' || isMobile === null) ? <AppHeader /> : ''}
      <div className='app-main' style={{ paddingTop: `${(isMobile === 'false' || isMobile === null) ? '60px' : '0px'}` }}>
        {(isMobile === 'false' || isMobile === null) ? <AppSidebar /> : ''}
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id="travel-page">
              {isLoading && <CustomSpinner />}
              <Container fluid className="px-0">
                <Row>
                  {isMobile === 'false' ? (
                    <Col xs={12}>
                      <div className="pageheader">
                        <DashBoardTitle dashBorardName="DISTANCE TRAVELLED" />
                      </div>
                    </Col>
                  ) : ''}
                  <Col lg={4}>
                    <div className="travelEntryCard">
                      <Row>
                        <Col xs={6}>
                          <div className="travelNum">{data.length}</div>
                          <div>Total Entry</div>
                        </Col>
                        <Col xs={6}>
                          <div className="travelNum">{totalKM}</div>
                          <div>Total KM</div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={8}>
                    <div className="travel-filter">
                      <Row>
                        <Col xs={4} lg={2}>
                          <FilterButton
                            onClick={() => setFilterModal(!filterModal)}
                            className={
                              filterbtnActive ? 'activeFilterBtn' : 'inActiveFilterBtn'
                            }
                          />
                        </Col>
                        <Col xs={2}>
                          <img
                            src={excelImg}
                            alt="excel"
                            className="excelIcon"
                            onClick={handleClickExcel}
                          />
                        </Col>

                        {(roleName === Roles.SH_NAME || roleName === Roles.TM_NAME) && (
                          <Col xs={6} lg={8} className="add-punch-in-btn">
                            <AddUserButton
                              name="Add Punch In"
                              onClick={() => handleIsModal('PunchIn')}
                            />
                          </Col>
                        )}
                      </Row>
                    </div>
                  </Col>
                </Row>

                {data.length > 0 &&
                  data.map((item, index) => (
                    <div className="travelCard" key={index}>
                      <div className="travelCard-img">
                        {!item.out_time &&
                          (roleName === Roles.SH_NAME ||
                            roleName === Roles.TM_NAME) && (
                            <div>
                              <Button
                                color="primary"
                                onClick={() => {
                                  handleIsModal('PunchOut');
                                  setPunchOutUserId(item.user_id);
                                  setPunchOutId(item.punchin_id);
                                  setPunchOutData({
                                    start: item.start_km,
                                    time: item.in_time,
                                  });
                                }}
                              >
                                Add Punch Out
                              </Button>
                            </div>
                          )}
                        {item.speedometer_image_in && (
                          <div onClick={() => toggleImgModal(1, index)}>
                            <img
                              src={item.speedometer_image_in}
                              className="punchInImg"
                              alt="Start KM"
                            />
                          </div>
                        )}
                        {item.speedometer_image_out && (
                          <div onClick={() => toggleImgModal(2, index)}>
                            <img
                              src={item.speedometer_image_out}
                              className="punchInImg"
                              alt="End KM"
                            />
                          </div>
                        )}
                      </div>
                      <Row className="ml-1 mt-1">
                        <b>Date :</b>&nbsp;{moment(item.date).format('MMM Do, YYYY')}
                      </Row>
                      <Row className="ml-1 mt-1">
                        <Col lg={4} className="pl-0">
                          <b>In Time :</b>&nbsp;
                          {moment(item.in_time).format('hh:mm a')}
                        </Col>
                        <Col lg={4} className="pl-0 pt-1">
                          <b>Out Time :</b>&nbsp;
                          {item.out_time
                            ? moment(item.out_time).format('hh:mm a')
                            : 'NA'}
                        </Col>
                        <Col lg={4} className="pl-0 pt-1">
                          <b>Duration :</b>&nbsp;{item.duration}
                        </Col>
                      </Row>
                      <Row className="ml-1 mt-1">
                        <Col lg={4} className="pl-0">
                          <b>Start KM :</b>&nbsp;{item.start_km} KM
                        </Col>
                        <Col lg={4} className="pl-0 pt-1">
                          <b>End KM :</b>&nbsp;
                          {item.end_km ? `${item.end_km} KM` : 'NA'}
                        </Col>
                        <Col lg={4} className="pl-0 pt-1">
                          <b>Total KM :</b>&nbsp;
                          {item.total_km ? `${item.total_km} KM` : 'NA'}
                        </Col>
                      </Row>
                      <Row className="ml-1 mt-1">
                        <b>TM / SH Name :</b>&nbsp;{item.tm_sh_name}
                      </Row>
                    </div>
                  ))}

                <Col xs={12}>
                  <div className="paginationWrapper">
                    <span className="page-select-title">Rows per page:</span>
                    &nbsp;&nbsp;
                    <select
                      className="form-control rows-per-page-select"
                      name="pageSize"
                      value={pageSize}
                      onChange={(e) => handleInputChange(e)}
                    >
                      <option key="5" value={5}>
                        5 Rows
                      </option>
                      <option key="10" value={10}>
                        10 Rows
                      </option>
                      <option key="15" value={15}>
                        15 Rows
                      </option>
                      <option key="20" value={20}>
                        25 Rows
                      </option>
                      <option key="25" value={25}>
                        30 Rows
                      </option>
                      <option key="30" value={50}>
                        50 Rows
                      </option>
                    </select>
                    &nbsp;&nbsp;
                    <div className="pageList">
                      <Pagination
                        margin={2}
                        page={page}
                        count={parseInt(data.length / pageSize)}
                        pageSize={pageSize}
                        totalRecords={parseInt(data.length || 0)}
                        onPageChange={handlePageChange}
                      ></Pagination>
                    </div>
                  </div>
                </Col>
              </Container>
              {punchInModal.punchIn && (
                <PunchInOutModal
                  handleIsModal={handleIsModal}
                  modalVariable={{
                    title: 'Punch In',
                    label: ['Start KM', 'In Time'],
                  }}
                  resetId={() => null}
                  fetchData={fetchData}
                  isMobile={isMobile}
                />
              )}
              {punchInModal.punchOut && (
                <PunchInOutModal
                  handleIsModal={handleIsModal}
                  fetchData={fetchData}
                  id={punchOutId}
                  userId={punchOutUserId}
                  punchOutData={punchOutData}
                  resetId={() => {
                    setPunchOutId(null);
                    setPunchOutUserId(null);
                    setPunchOutData({});
                  }}
                  modalVariable={{
                    title: 'Punch Out',
                    label: ['End KM', 'Out Time'],
                  }}
                  isMobile={isMobile}
                />
              )}

              {/* Filter Modal */}
              <Modal
                isOpen={filterModal}
                toggle={() => setFilterModal(!filterModal)}
                centered
                id="travel-filter-modal"
              >
                <ModalBody>
                  <div className="ModalArea">
                    <Container>
                      <Row>
                        <Col xs={12}>
                          <div className="modalHeading">
                            <div className="title">Filter</div>
                            <div className="closeButton">
                              <img
                                src={closeImg}
                                alt="close"
                                onClick={() => setFilterModal(!filterModal)}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12}>
                          <Form onSubmit={handleApplyFilter}>
                            <FormGroup>
                              {roleName === Roles.BH_NAME ? (
                                <div className="filterDropdown filterInput">
                                  <label htmlFor="nationalHeadName">
                                    National Head:
                                  </label>
                                  <select
                                    name="nationalHeadName"
                                    id="nationalHeadName"
                                    value={nhId}
                                    onChange={(e) => handleChange(e)}
                                  >
                                    <option value={''}>All</option>
                                    {nhList.length > 0 &&
                                      nhList.map((elem, index) => {
                                        const { id, first_name, last_name } = elem;
                                        return (
                                          <option
                                            value={id}
                                            key={index}
                                          >{`${first_name} ${last_name}`}</option>
                                        );
                                      })}
                                  </select>
                                </div>
                              ) : (
                                ''
                              )}
                            </FormGroup>
                            <FormGroup>
                              {roleName === Roles.BH_NAME ||
                                roleName === Roles.NH_NAME ? (
                                <div className="filterDropdown filterInput">
                                  <label htmlFor="stateHeadName">State Head:</label>
                                  <select
                                    name="stateHeadName"
                                    id="stateHeadName"
                                    value={shId}
                                    onChange={(e) => handleChange(e)}
                                  >
                                    <option value={''}>All</option>
                                    {shList.length > 0 &&
                                      shList.map((elem, index) => {
                                        const { id, first_name, last_name } = elem;
                                        return (
                                          <option value={id} key={index}>
                                            {first_name} {last_name}
                                          </option>
                                        );
                                      })}
                                  </select>
                                </div>
                              ) : (
                                ''
                              )}
                            </FormGroup>
                            <FormGroup>
                              {roleName === Roles.BH_NAME ||
                                roleName === Roles.NH_NAME ||
                                roleName === Roles.SH_NAME ? (
                                <>
                                  <div className="filterDropdown filterInput">
                                    <label htmlFor="stateName">State:</label>
                                    <select
                                      name="stateName"
                                      id="stateName"
                                      value={stateId}
                                      onChange={(e) => handleChange(e)}
                                    >
                                      <option value={''}>All</option>
                                      {stateFilterList.length > 0 &&
                                        stateFilterList.map((elem, index) => {
                                          const { state_id, name } = elem;
                                          return (
                                            <option value={state_id} key={index}>
                                              {name}
                                            </option>
                                          );
                                        })}
                                    </select>
                                  </div>
                                  <div className="filterDropdown filterInput">
                                    <label htmlFor="tmName">Territory Manager:</label>
                                    <select
                                      name="tmName"
                                      id="tmName"
                                      value={tmId}
                                      onChange={(e) => handleChange(e)}
                                    >
                                      <option value={''}>All</option>
                                      {tmFilterList.length > 0 &&
                                        tmFilterList.map((elem, index) => {
                                          const {
                                            user_id,
                                            first_name,
                                            last_name,
                                          } = elem;
                                          return (
                                            <option value={user_id} key={index}>
                                              {first_name} {last_name}
                                            </option>
                                          );
                                        })}
                                    </select>
                                  </div>
                                </>
                              ) : (
                                ''
                              )}
                            </FormGroup>
                            <FormGroup>
                              <div className="filterDropdown filterInput">
                                <label htmlFor="territoryName">Territory:</label>
                                <select
                                  name="territoryName"
                                  id="territoryName"
                                  value={territoryId}
                                  onChange={(e) => handleChange(e)}
                                >
                                  <option value={''}>All</option>
                                  {territoryFilterList.length > 0 &&
                                    territoryFilterList.map((elem, index) => {
                                      // territory_id from getTerritoryid
                                      // id : state_head_tm by id
                                      const {
                                        id = null,
                                        territory_id = null,
                                        name,
                                      } = elem;
                                      return (
                                        <option value={territory_id || id} key={index}>
                                          {name}
                                        </option>
                                      );
                                    })}
                                </select>
                              </div>
                            </FormGroup>
                            <div className="date-filter">
                              <Row>
                                <Col xs={6}>
                                  <FormGroup>
                                    <Label className="common-input-label">
                                      Start Date
                                    </Label>
                                    <input
                                      type="date"
                                      name="startDate"
                                      id="startDate"
                                      value={startDate}
                                      onChange={(e) => handleChange(e)}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col xs={6}>
                                  <FormGroup>
                                    <Label className="common-input-label">
                                      End Date
                                    </Label>
                                    <input
                                      type="date"
                                      name="endDate"
                                      id="endDate"
                                      value={endDate}
                                      onChange={(e) => handleChange(e)}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </div>
                            <div className="btnGroup">
                              <CommonButton
                                name="Reset"
                                onClick={handleResetFilter}
                                btnClass={'btnSecondary'}
                                type="button"
                              />
                              <CommonButton
                                name="Apply"
                                btnClass={'btnPrimary'}
                                type="submit"
                              />
                            </div>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </ModalBody>
              </Modal>

              {/* Image modal */}
              {imgModal && (
                <Lightbox mainSrc={imgUrl} onCloseRequest={() => setImgModal(false)} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
